var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md5":"","lg5":""}},[_c('CaseRegistrationStats',{attrs:{"data":_vm.caseRegistrationStats}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md7":"","lg7":""}},[_c('GrossingByDoctors',{staticClass:"ml-5",attrs:{"data":_vm.grossingByDoctorsStats}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-88a3801c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Walldash/FirstScreen.vue
// module id = null
// module chunks = 